import { buildFunctionUrl, getJson } from "../../services/functionApi";
import type { CurrentMember } from "./CurrentMember";
import type { TeamRole } from "./TeamRole";

const KNOWN_ROLES: TeamRole[] = ["Spieler", "Kapitaen", "Admin"];

/**
 * A role we do not know is no role. Silently promoting an unexpected value would be the one
 * mistake here that hands somebody rights they were never given.
 */
function readRole(value: unknown): TeamRole | null {
  return typeof value === "string" && (KNOWN_ROLES as string[]).includes(value)
    ? (value as TeamRole)
    : null;
}

/**
 * Who the signed-in caller is, according to the server. This replaces "take the first team of
 * the list", which only ever looked like an account-to-team assignment because the club runs
 * one team.
 */
export async function fetchCurrentMember(accessToken: string | null): Promise<CurrentMember> {
  const result = await getJson<Partial<CurrentMember>>(buildFunctionUrl("me", "accounts"), accessToken, "accounts");

  if (result == null || typeof result !== "object") {
    return { playerName: "", teamName: "", role: null, isVerified: false };
  }

  return {
    playerName: result.playerName ?? "",
    teamName: result.teamName ?? "",
    role: readRole(result.role),
    isVerified: result.isVerified === true,
  };
}
